import { useState } from "react";
import "./ProductCard.css";
import { fileURL } from "../../utils/fileURL";

function ProductCard({ data, onClick }) {
  // Guardamos la url que fallo, no un booleano: si el producto cambia de
  // imagen la card se recupera sola sin quedar pegada al placeholder.
  const [urlFallida, setUrlFallida] = useState(null);

  const imageUrl = data?.url_image ? fileURL(data.url_image) : null;
  const mostrarImagen = Boolean(imageUrl) && urlFallida !== imageUrl;

  const formatUSD = (value) => {
    if (value === null || value === undefined || value === "") return "$0.00";
    const n = Number(value);
    if (Number.isNaN(n)) return "$0.00";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(n);
  };

  const isOutOfStock = Number(data?.cantidad_disponible) === 0;

  // Sin stock igual se abre: la ficha muestra specs, peso y el PDF tecnico,
  // que es lo que viene a buscar quien rastrea un part number.
  const handleOpen = () => {
    if (typeof onClick === "function") onClick();
  };

  return (
    <div
      className={`adc-card ${isOutOfStock ? "adc-card--sin-stock" : ""}`}
      role="button"
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleOpen();
        }
      }}
    >
      <div className="adc-card-image">
        {mostrarImagen ? (
          <img
            src={imageUrl}
            alt={data?.nombre || "Product"}
            onError={() => setUrlFallida(imageUrl)}
          />
        ) : (
          <div className="adc-no-image">No image</div>
        )}
      </div>

      <div className="adc-card-body">
        <div className="adc-card-top">
          {/* El estado va en el cuerpo y no encima de la foto: un punto de
              color alcanza y deja ver el producto completo. */}
          <span className={`adc-stock ${isOutOfStock ? "out" : "in"}`}>
            <i className="adc-stock-dot" aria-hidden="true" />
            {isOutOfStock ? "Out of stock" : "In stock"}
          </span>

          <h3 className="adc-card-title">{data?.nombre || "—"}</h3>

          {data?.no_parte ? (
            <p className="adc-card-part">
              <span className="adc-card-part-label">Part no.</span>
              <span className="adc-card-part-value">{data.no_parte}</span>
            </p>
          ) : null}
        </div>

        <div className="adc-card-bottom">
          <p className="adc-card-price">{formatUSD(data?.precio_unitario)}</p>

          <button
            type="button"
            className={`adc-card-btn ${isOutOfStock ? "adc-card-btn--cotizar" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              handleOpen();
            }}
          >
            {isOutOfStock ? "Request quote" : "View details"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
